"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _epics = require("settings-ui-sdk/AdsAccounts/epics");

var _epics2 = require("settings-ui-sdk/AdsPixel/epics");

var _epics3 = require("settings-ui-sdk/AdsROI/epics");

var _modalEpics = require("./modalEpics");

var _saveStagedChangesEpic = _interopRequireDefault(require("./saveStagedChangesEpic"));

var _oauthErrorNotificationEpic = _interopRequireDefault(require("./oauthErrorNotificationEpic"));

var _connectAccountErrorNotificationEpic = _interopRequireDefault(require("./connectAccountErrorNotificationEpic"));

var _default = (0, _reduxObservable.combineEpics)(_epics.fetchAdAccounts, _epics.getConnectedUsers, _epics2.fetchPixels, _epics.deleteAdAccount, _epics.deleteUserAuth, _epics.setAdAccountTracking, _epics2.createAndInstallPixels, _epics2.uninstallPixel, _modalEpics.shouldDisplayErrorBannerWhenFailed, _modalEpics.refetchAuthedUsersAfterAdAccountDeletion, _modalEpics.refetchSelectedPagesAfterPageSelection, _modalEpics.refetchSelectedPagesAfterPageDeletion, _modalEpics.refetchPixelsAfterInstallation, _modalEpics.closePixelModalAfterInstallation, _epics3.fetchCostPerLead, _epics3.syncCostPerLead, _epics3.syncROISetting, _epics3.fetchPortalCurrencyInfo, _saveStagedChangesEpic.default, _oauthErrorNotificationEpic.default, _connectAccountErrorNotificationEpic.default, _epics.fetchAvailableLeadSyncingEntities, _epics.fetchSelectedLeadSyncingEntities, _epics.selectLeadSyncingEntities, _epics.unsubscribeLeadSyncingEntity, _epics.changeEmailLessFormSubmissionSetting, _modalEpics.refetchAccountsAfterDeletionFails);

exports.default = _default;
module.exports = exports.default;